import { log } from "@tumbodash/browserPackages";
import type { Party, Player } from "../../types.js";

function getActivePlayers(party: Party): Player[] {
	log.fx("module:party:getActivePlayers");
	const activePlayers: Player[] = [];
	Object.keys(party.players).forEach((key) => {
		if (party.players[key].isActive)
			activePlayers.push(Object.assign({}, party.players[key]));
	});
	return activePlayers;
}

export default getActivePlayers;
